import { WidgetTypes } from '../../../../../common/types/api/report'
import type { BlocksHtml, BlocksPipes, ContentBlockGallery, WidgetGallery } from '../../../../../common/types/api/page'
import { addHtml } from '../../helper/addHtml'
import { addPipes } from '../../helper/addPipes'

interface PropsRow {
    lineHeight: number
    maxHeight: number
    maxWidth: number
    id: number
}

export const GALLERY_CONTENT_MIN_WIDTH = 100;
export const GALLERY_CONTENT_MIN_HEIGHT = 100;

const getW = (width: number, maxWidth: number): number => Math.round((width / maxWidth) * 100)
const getH = (height: number, lineHeight: number): number => {
    /*            
       1 lineHeight = 100px 
        h = (height * lineHeight) / 100px
    */
    return (height * lineHeight) / 100
}

export function getGalleryRowLayout(
    widgets: (WidgetGallery|ContentBlockGallery)[],
    indexRow: number,
    editMode: boolean,
    propsRow: PropsRow
): {
    grid: ItemGallery
    widget: WidgetGallery|ContentBlockGallery
}[] {
    if (!Array.isArray(widgets)) return []

    const usedSize = widgets.reduce(
        (state, widget) => ({
            height: widget.height + state.height,
            width: widget.width + state.width
        }),
        {
            height: 0,
            width: 0
        }
    )

    return widgets.map((widget, indexCollumn) => {
        const freeSpace = propsRow.maxWidth - usedSize.width

        const w = getW(widget.width, propsRow.maxWidth)

        const maxW = getW(Math.floor(freeSpace + widget.width), propsRow.maxWidth)

        return {
            grid: {
                i: `widget-${indexRow}-${indexCollumn}`,
                cols: [],
                // maxW: maxW > 5 ? maxW : w,
                maxW: Math.round(widget.width + freeSpace),
                minW: GALLERY_CONTENT_MIN_WIDTH,
                //  getW(100),
                maxH: getH(propsRow.maxHeight, propsRow.lineHeight),
                minH: getH(100, propsRow.lineHeight),
                x: indexCollumn,
                y: 0,
                w: widget.width,
                h: getH(widget.height, propsRow.lineHeight),
                static: false,
                isResizable: editMode,
                resizeHandles: ['n']
            },
            widget
        }
    })
}

export function getDefaultContent(
    type: WidgetTypes, id: number, 
    width = GALLERY_CONTENT_MIN_WIDTH,
    height = GALLERY_CONTENT_MIN_HEIGHT
): WidgetGallery | ContentBlockGallery {
    switch(type) {
        case WidgetTypes.GALLERY:
            return getDefaultWidget(id, width, height)
        case WidgetTypes.HTML:
            return getDefaultBlockHTML(id, width, height)
        case WidgetTypes.PIPES:
            return getDefaultBlockPipes(id, width, height)
        default:
            return {} as WidgetGallery
    }
}

export function getDefaultWidget(    
    id: number,    
    width = GALLERY_CONTENT_MIN_WIDTH,
    height = GALLERY_CONTENT_MIN_HEIGHT
): WidgetGallery {
    return {
        width,
        height,
        id,
        showSpan: false,
        showTitle: true,
        span: 'last hour',
        widgetId: 1,
        unfollowSpan: false,
        titlePosition: 'center'
    }
}

export function getDefaultBlockPipes(    
    id: number,    
    width = GALLERY_CONTENT_MIN_WIDTH,
    height = GALLERY_CONTENT_MIN_HEIGHT
): ContentBlockGallery {
    return {
        id,
        height,
        width,
       content : addPipes(-1) as BlocksPipes
    }
}

export function getDefaultBlockHTML(    
    id: number,    
    width = GALLERY_CONTENT_MIN_WIDTH,
    height = GALLERY_CONTENT_MIN_HEIGHT
): ContentBlockGallery {
    return {
        id,
        height,
        width,
       content : addHtml(-1) as BlocksHtml
    }
}